import "./DesktopSignupModal.scss";
import edit from "../../common/assets/svg/profileEdit.svg";
import { get, useForm } from "react-hook-form";
import { useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import DialCodePicker, { CountryCodeData } from "../dialCodePicker";
import { getCountryData } from "../../common/utils/country-data-util";
import countrycodedropdown from "../../common/assets/svg/dropdowncountrycode.svg";
import { updateProfileRequest } from "../../common/features/auth/AuthActions";
import { UpdateUserDetailsPayload } from "../../common/features/user/userModels";
import { updateUserDetailsRequest } from "../../common/features/user/userActions";
// import { ReactComponent as CancelIcon } from "../../common/assets/svg/cancelIconnew.svg";
// import SignInForm from "../Signupnew/siginInContainer";
import { getCookie } from "../../helper/cookieHelper";
import { USER_DETAILS, USER_ID } from "../../common/constants";

interface DesktopSignupModalprops {
  isOpen?: boolean;
  onClose?: any;
  signInPopupDesktop?: boolean;
  setCurrentPage?: any;
  data?: any;
}
const DesktopSignupModal: React.FC<DesktopSignupModalprops> = ({
  isOpen,
  onClose,
  signInPopupDesktop,
  setCurrentPage,
  data,
}) => {
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    getValues,
    watch,
  } = useForm({
    defaultValues: {
      mobile: '',
      firstName: '',
      lastName: '',
      email: '',
    },
  });

  const restaurantDetails = useSelector((state: any) => state.restaurant.currentRestaurantDetail);
  const userCountry = useSelector((state: any) => state.auth?.countryCode);
  const emailDomains = ['.com', '@gmail.com', '@outlook.com', '@icloud.com', '@yahoo.com'];
  const dispatch = useDispatch();
  const [customTag, setCustomTag] = useState('');
  const [showOtherTag, setShowOtherTag] = useState(false);
  const [tags, setTags] = useState<string[]>([]);

  const [showDialCodePicker, setShowDialCodePicker] = useState(false);
  const [countrySelected, setCountrySelected] = useState<any>(false);
  const [countryData, setCountryData] = useState<CountryCodeData>(
    getCountryData(userCountry ? userCountry : '', restaurantDetails.country)
  );

  const customerDetails = getCookie(USER_DETAILS) || {};
  const customerName = customerDetails?.firstName || customerDetails?.name || "";
  const customerNumber = customerDetails?.mobilePhone;
  const customeremail = customerDetails?.email || "";
  const customerId = getCookie(USER_ID);

  useEffect(() => {
    if (customerNumber) {
      const number = customerNumber.split('-')[1];
      setValue('mobile', number);
    }
    if (customerName) {
      setValue('firstName', customerName);
    }
    if (
      customeremail ||
      (data?.inputData && restaurantDetails?.platformConfiguration?.sendOtpViaEmail)
    ) {
      if (restaurantDetails?.platformConfiguration?.sendOtpViaEmail) {
        setValue('email', data?.inputData);
      } else {
        setValue('email', customeremail);
      }
    }
  }, []);

  const handleDomainClick = (domain: string) => {
    const currentEmail = getValues('email') || '';

    let newEmail = currentEmail;

    if (domain.startsWith('@')) {
      const atIndex = currentEmail.indexOf('@');

      if (atIndex !== -1) {
        // Replace domain starting from '@'
        newEmail = currentEmail.slice(0, atIndex) + domain;
      } else {
        // Append '@domain' if no '@' exists
        newEmail = currentEmail + domain;
      }
    } else if (domain.startsWith('.')) {
      const atIndex = currentEmail.indexOf('@');

      if (atIndex !== -1) {
        const afterAt = currentEmail.slice(atIndex);
        const dotIndex = afterAt.indexOf('.');
        if (dotIndex !== -1) {
          // Replace from dot after '@'
          newEmail = currentEmail.slice(0, atIndex + dotIndex) + domain;
        } else {
          // No dot after @, just append domain
          newEmail = currentEmail + domain;
        }
      } else {
        // No '@', just append domain
        newEmail = currentEmail + domain;
      }
    }

    setValue('email', newEmail);
  };

  const updateUserDetailsSuccess = useSelector((state: any) => state.user.updateUserDetailsSuccess);
  const UpdateProfileSuccess = useSelector((state: any) => state.auth.UpdateProfileSuccess);
  const hasSubmitted = useRef(false);
  const updateUserDetailsuseddata: string = useSelector(
    (state: any) => state.user.usedMobileorEmail
  );
  console.log({ updateUserDetailsuseddata });
  const watchedemail = watch('email');
  // console.log({watchedemail});

  const watchedponenumber = watch('mobile');

  console.log({ watchedponenumber });
  const UpdateProfileErrorMessage = useSelector(
    (state: any) => state.auth.UpdateProfileErrorMessage
  );
  const coerceErrorMessage = (value: any) => {
    if (typeof value === 'string') return value;
    if (value && typeof value?.message === 'string') return value.message;
    return '';
  };
  const backendErrorMessage = coerceErrorMessage(UpdateProfileErrorMessage);
  const hasBackendError = backendErrorMessage !== '';
  console.log({ UpdateProfileErrorMessage, backendErrorMessage });

  useEffect(() => {
    if ((UpdateProfileSuccess || updateUserDetailsSuccess) && hasSubmitted.current) {
      onClose();
    }
  }, [updateUserDetailsSuccess, UpdateProfileSuccess]);

  const onSubmit = (data: any) => {
    // Block API call if current input matches a prior "linked" error condition
    const isMobileLinkedError =
      restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
      backendErrorMessage.toLowerCase().includes('linked') &&
      updateUserDetailsuseddata === `${countryData.code}-${watchedponenumber}`;

    const isEmailLinkedError =
      !restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
      backendErrorMessage.toLowerCase().includes('linked') &&
      updateUserDetailsuseddata === watchedemail;

    if (isMobileLinkedError || isEmailLinkedError) {
      return;
    }

    const updateProfilePayload: UpdateUserDetailsPayload & {
      sendOtpViaEmail?: boolean;
    } = {
      customerId: customerId && customerId !== 'undefined' ? customerId : '',
      mobilePhone: `${countryData.code}-${data.mobile}`,
      firstName: data.firstName,
      lastName: data.lastName,
      email: data.email,
      sendOtpViaEmail: restaurantDetails?.platformConfiguration?.sendOtpViaEmail,
      isNewUser: true,
    };
    if (dobMonth && dobDay && dobYear) {
      const dobMonthNum = String(months.indexOf(dobMonth) + 1).padStart(2, '0');
      updateProfilePayload.dob = `${dobYear}-${dobMonthNum}-${dobDay}`;
    }
    sessionStorage.setItem('pendingLoyaltyUserData', JSON.stringify({
      phone: `${countryData.code}-${data.mobile}`,
      firstName: data.firstName,
      email: data.email,
    }));
    hasSubmitted.current = true;
    dispatch(updateProfileRequest(updateProfilePayload));
  };

  const [isEdit, setIsEdit] = useState(false);

  const [dobMonth, setDobMonth] = useState('');
  const [dobDay, setDobDay] = useState('');
  const [dobYear, setDobYear] = useState('');
  const [openPicker, setOpenPicker] = useState<string | null>(null);

  const months = ['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
  const days = Array.from({ length: 31 }, (_, i) => String(i + 1).padStart(2, '0'));
  const currentYear = new Date().getFullYear();
  const years = Array.from({ length: currentYear - 1923 }, (_, i) => String(currentYear - i));

  const emailOtp = false;
  useEffect(() => {
    if (restaurantDetails?.platformConfiguration?.sendOtpViaEmail) {
      setIsEdit(true);
    } else {
      setIsEdit(false);
    }
  }, [restaurantDetails?.platformConfiguration?.sendOtpViaEmail]);

  return (
    //     <div className="container-Desktop-signup">

    //       <div className="modal-Desktop-signup">
    //                               <CancelIcon className="close-btnZa-Desktop-signup" onClick={onClose}/>
    //   {/* {
    //         !customerId  && <SignInForm isOpen={isOpen} onClose={onClose}  signInPopupDesktop={true}/>
    //       } */}

    //       </div>
    //     </div>
    <div>
      <div className="header-Desktop-signup">
        <h3 className="title-Desktop-signup">Sign up</h3>
        <p className="subtitle-Desktop-signup">
          Welcome, New user. Please enter your details to proceed.
        </p>
      </div>

      <form onSubmit={handleSubmit(onSubmit)} className="form-Desktop-signup">
       <div className="scrollable-form-Desktop-signup" style={{ overflowY: 'auto', maxHeight: '60vh', scrollbarWidth: 'none', msOverflowStyle: 'none', padding: '4px 4px' } as React.CSSProperties}>
        <div className="field-Desktop-signup mobile-container-D">
          <label>Mobile Number*</label>
          <div
            className="mobile-wrapper-Desktop-signup"
            style={{
              border:
                restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
                hasBackendError
                  ? '1px solid #e52333'
                  : undefined,
              color:
                restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
                hasBackendError
                  ? '#e52333'
                  : undefined,
            }}
          >
            <div className="countrycode-input-container-Desktop-signup">
              <div
                className="countryCodeContainer-Desktop-signup"
                onClick={() => setShowDialCodePicker(!showDialCodePicker)}
              >
                <img
                  src={countryData.flag}
                  height="24px"
                  width="24px"
                  className="flag-Desktop-signup"
                />
                <img src={countrycodedropdown} alt="" className="dropdown-icon-Desktop-signup" />
                <span className="codeText-Desktop-signup">{countryData.code}</span>
              </div>

              <span className="divider-Desktop-signup" />

              <input
                className="input-Desktop-signup"
                {...register('mobile', {
                  required: 'Mobile number is required',
                  pattern: {
                    value: /^[0-9]{10}$/,
                    message: 'Enter a valid 10-digit mobile number',
                  },
                })}
                style={{
                  color:
                    restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
                    hasBackendError
                      ? '#e52333'
                      : undefined,
                }}
                maxLength={10}
                placeholder="(808) 555-0111"
                readOnly={!isEdit}
                type="text"
                inputMode="numeric"
                onKeyDown={e => {
                  if (!/[0-9]/.test(e.key) && e.key !== 'Backspace' && e.key !== 'Tab') {
                    e.preventDefault();
                  }
                }}
              />
            </div>
          </div>

          <div className="dialCode">
            <DialCodePicker
              showPicker={showDialCodePicker}
              setShowPicker={setShowDialCodePicker}
              setCountrySelected={setCountrySelected}
              setCountryData={setCountryData}
              inputValue=""
              countryCode={customerNumber?.split('-')[0]}
              setIsMobile={true}
              onlyMobile={true}
              isMobileNot={true}
              width="50%"
              top="160px"
            />
          </div>

          {errors.mobile && <span className="error-Desktop-signup">{errors.mobile.message}</span>}

          {restaurantDetails?.platformConfiguration?.sendOtpViaEmail && hasBackendError && (
            <span className="error-Desktop-signup">{backendErrorMessage}</span>
          )}
        </div>

        <div className="name-fields-Desktop-signup">
          <div className="field-Desktop-signup">
            <label>First Name*</label>
            <input
              className="input-Desktop-signup"
              autoComplete="new-password"
              inputMode="text"
              onPaste={e => {
                const pastedText = e.clipboardData.getData('text');
                if (!/^[a-zA-Z]+$/.test(pastedText)) {
                  e.preventDefault();
                }
              }}
              onInput={e => {
                const input = e.target as HTMLInputElement;
                input.value = input.value.replace(/[^a-zA-Z]/g, '');
              }}
              onKeyDown={e => {
                const key = e.key;
                if (key.length > 1 || /^[a-zA-Z]$/.test(key)) {
                  return;
                }
                e.preventDefault();
              }}
              maxLength={32}
              {...register('firstName', {
                required: 'First name is required',
                pattern: {
                  value: /^[A-Za-z]+$/,
                  message: 'Only alphabets allowed',
                },
              })}
              type="text"
            />
            {errors.firstName && (
              <span className="error-Desktop-signup">{errors.firstName.message}</span>
            )}
          </div>

          <div className="field-Desktop-signup">
            <label>Last Name</label>
            <input
              className="input-Desktop-signup"
              autoComplete="new-password"
              inputMode="text"
              onPaste={e => {
                const pastedText = e.clipboardData.getData('text');
                if (!/^[a-zA-Z]+$/.test(pastedText)) {
                  e.preventDefault();
                }
              }}
              onInput={e => {
                const input = e.target as HTMLInputElement;
                input.value = input.value.replace(/[^a-zA-Z]/g, '');
              }}
              onKeyDown={e => {
                const key = e.key;
                if (key.length > 1 || /^[a-zA-Z]$/.test(key)) {
                  return;
                }
                e.preventDefault();
              }}
              maxLength={32}
              {...register('lastName')}
              // readOnly={!isEdit}
              type="text"
            />
            {errors.lastName && (
              <span className="error-Desktop-signup">{errors.lastName.message}</span>
            )}
          </div>
        </div>

        <div className="mail-field-Desktop-signup ">
          <label>Email*</label>
          <input
            className="input-Desktop-signup"
            style={{
              border:
                !restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
                hasBackendError
                  ? '1px solid #e52333'
                  : undefined,
              color:
                !restaurantDetails?.platformConfiguration?.sendOtpViaEmail &&
                hasBackendError
                  ? '#e52333'
                  : undefined,
            }}
            autoComplete="new-password"
            inputMode="text"
            type="text"
            readOnly={restaurantDetails?.platformConfiguration?.sendOtpViaEmail}
            onPaste={e => {
              const pastedText = e.clipboardData.getData('text');
              if (!/^[a-zA-Z0-9@._%+-]$/.test(pastedText)) {
                e.preventDefault();
              }
            }}
            onKeyDown={e => {
              const key = e.key;
              if (
                key === 'Backspace' ||
                key === 'Delete' ||
                key === 'ArrowLeft' ||
                key === 'ArrowRight' ||
                key === 'Tab'
              ) {
                return;
              }
              const allowedChars = /^[a-zA-Z0-9@._%+-]$/;
              if (!allowedChars.test(key)) {
                e.preventDefault();
              }
            }}
            maxLength={32}
            {...register('email', {
              required: 'Email is required',
              pattern: {
                value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/,
                message: 'Enter a valid email',
              },
            })}
          />
          {errors.email && <span className="error-Desktop-signup">{errors.email.message}</span>}

          {!restaurantDetails?.platformConfiguration?.sendOtpViaEmail && hasBackendError && (
            <span className="error-Desktop-signup">{backendErrorMessage}</span>
          )}
        </div>

        {!restaurantDetails?.platformConfiguration?.sendOtpViaEmail && (
          <div className="domain-buttons">
            {emailDomains.map(domain => (
              <button type="button" key={domain} onClick={() => handleDomainClick(domain)}>
                {domain}
              </button>
            ))}
          </div>
        )}

        {/* <div className="dob-section">
          <p className="dob-heading">
            Date Of Birth (MM-DD-YYYY)
          </p>
          <div className="dob-pickers-row">
            {([
              { id: 'month', value: dobMonth, setter: setDobMonth, placeholder: 'Jan', options: months },
              { id: 'day',   value: dobDay,   setter: setDobDay,   placeholder: '01',  options: days   },
              { id: 'year',  value: dobYear,  setter: setDobYear,  placeholder: '2000',options: years  },
            ] as { id: string; value: string; setter: (v: string) => void; placeholder: string; options: string[] }[]).map(({ id, value, setter, placeholder, options }) => {
              const isOpen = openPicker === id;
              return (
                <div key={id} className="dob-picker-item">
                  <div
                    onClick={() => setOpenPicker(isOpen ? null : id)}
                    className={`dob-picker-trigger${isOpen ? ' open' : ''}`}
                  >
                    <span className={`dob-picker-value${value ? ' has-value' : ''}`}>
                      {value || placeholder}
                    </span>
                    <svg
                      width="12" height="7" viewBox="0 0 12 7" fill="none"
                      className={`dob-picker-arrow${isOpen ? ' open' : ''}`}
                    >
                      <path d="M1 1L6 6L11 1" stroke="#666" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  {isOpen && (
                    <div className="dob-picker-dropdown">
                      {options.map(opt => {
                        const isSelected = value === opt;
                        return (
                          <div
                            key={opt}
                            onClick={() => { setter(opt); setOpenPicker(null); }}
                            className={`dob-picker-option${isSelected ? ' selected' : ''}`}
                          >
                            {opt}
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </div> */}
        </div>
        {
          <div
            className="button-group-Desktop-signup"
            style={{
              marginTop: restaurantDetails?.platformConfiguration?.sendOtpViaEmail ? '55px' : '0px',
            }}
          >
            <button
              type="button"
              className="cancel-btn-Desktop-signup"
              onClick={() => {
                setCurrentPage('signin');
              }}
            >
              Change
            </button>
            <button type="submit" className="submit-btn-Desktop-signup">
              Continue
            </button>
          </div>
        }
      </form>
    </div>
  );
};

export default DesktopSignupModal;
